'use client'

import color from '@ui/style/color.theme'

interface Icon32PrintProps {
	isDark?: boolean
}
export const Icon32Print = ({ isDark }: Icon32PrintProps) => {
	const colorValue = isDark ? color.colWhite : color.colBlack
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
		>
			<path
				d="M7 16C7 14.8954 7.89543 14 9 14H23C24.1046 14 25 14.8954 25 16V25H7V16Z"
				stroke={colorValue}
				strokeWidth="1.8"
			/>
			<rect x="11" y="8" width="10" height="6" stroke={colorValue} strokeWidth="1.8" />
			<path d="M12 21H20V25H12V21Z" stroke={colorValue} strokeWidth="1.8" />
			<circle cx="22" cy="17.2" r="1" fill={colorValue} />
		</svg>
	)
}
